const PREFIX = 'LOCATION/';

export const LOCATION_LIST = `${PREFIX}LIST`;
export const LOCATION_RETRIEVE = `${PREFIX}RETRIEVE`;
